import {
  ComponentConfig,
  ComponentType,
  FlexDirection,
  LayoutTypes,
} from "../services/types/ComponentTypes";

/** Tab hub shell — document listing injected at runtime from API configs 189/194. */
export const screen_197_bill_release_hub: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    screenId: "197",
    title: "Bill wise release",
    style: {
      backgroundColor: "#F9FAFB",
    },
    childComponents: [
      {
        componentType: ComponentType.CUSTOM,
        customType: "billReleaseTabs",
      },
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12,
          padding: 16,
        },
        childComponents: [],
      },
    ],
  },
];
